export const shippingDestinationValues = {
  INSTALLATION_PARTNER: "Installation Partner",
  STAGING_WAREHOUSE: "Staging Warehouse",
  CUSTOMER_SITE: "Customer Site",
};

export const shippingDestinationValuesBulkOrder = {
  STAGING_WAREHOUSE: "Staging Warehouse",
  INSTALLATION_PARTNER: "Installation Partner",
};

export const deliveryMethodValues = {
  STANDARD: "Standard Delivery",
  EXPEDITED: "Expedited Delivery",
};
